export class AuthService {
    constructor(apiService) {
        this.apiService = apiService;
    }
    async login(name, email) {
        const response = await this.apiService.post('auth', { name, email });
        if (!response.ok) {
            throw new Error('Ha ocurrio un error al efectuar el login.');
        }
        const content = await response.json();
        return content.accessToken;
    }
}
